import { THEME_TYPE } from '../../../../../ui-lib/consts';
import { MAP_VIEW_MODE } from '../../../../../ui-lib/modules/Map/controls/StyleControl/enums/map-view-mode';
import { PREFERENCE_TIME_FORMAT } from '../../../elements/RedesignedHeader/components/UserProfile/components/ProfileDrawerContent/components/TimeFormatRadio/enums/preference-time-format';
import { DISTANCE_UNIT } from '../../../consts/distance-units';
import { LOCALE_KEY } from '../../../consts/languages';
import { PACK } from '../../../consts/packs';
import { PAGE } from '../../../consts/pages';
import { changeLanguage } from '../../../services/translations/utils';
import { getCurrentPack } from '../../../utils';
import { TemperatureUnit } from '../../../utils/temperature';
import { CHANGE_USER_PREFERENCE, SET_USER_PREFERENCES } from '../const/action-types';
import { PREFERENCE, PREFERENCES_ACTIONS } from '../const/preferences';
import { UserPreferencesReduxState } from '../reducer/UserPreferencesReduxState.types';
import { getUserPreferences } from '../api';

type Dispatch = (action: any) => void;

export const changeUserPreference = (key: string, value: any) => {
  return (dispatch: Dispatch) => {
    dispatch({ type: CHANGE_USER_PREFERENCE, payload: { key, value } });
  };
};

export const setSuvMapStyle = (mapStyle: string) => {
  return (dispatch: Dispatch) => {
    dispatch(changeUserPreference(PREFERENCE.SUV_MAP_STYLE, mapStyle));
  };
};

export const setSuvSideBarOpen = (opened: boolean) => {
  return (dispatch: Dispatch) => {
    dispatch(changeUserPreference(PREFERENCE.SUV_SIDEBAR_OPEN, opened));
  };
};

export const setSuvSelectedGroup = (groupId: number | 'map_view') => {
  return (dispatch: Dispatch) => {
    dispatch(changeUserPreference(PREFERENCE.SUV_SELECTED_GROUP, groupId));
  };
};

export const setUserLocale = (locale: string) => {
  return (dispatch: Dispatch) => {
    dispatch(changeUserPreference(PREFERENCE.LOCALE, locale));
  };
};

export const setNotificationsSounds = (enabledSound: boolean) => {
  return (dispatch: Dispatch) => {
    dispatch(changeUserPreference(PREFERENCE.SOUND, enabledSound));
  };
};

export const setTimezone = (timezone: string) => {
  return (dispatch: Dispatch) => {
    dispatch(changeUserPreference(PREFERENCE.TIMEZONE, timezone));
  };
};

export const setDefaultApp = (app: string) => {
  return (dispatch: Dispatch) => {
    dispatch(changeUserPreference(PREFERENCE.DEFAULT_APP, app));
  };
};

export const setDistanceUnits = (units: DISTANCE_UNIT) => {
  return (dispatch: Dispatch) => {
    dispatch(changeUserPreference(PREFERENCE.DISTANCE_UNIT, units));
  };
};

export const setTemperatureUnits = (units: TemperatureUnit) => {
  return (dispatch: Dispatch) => {
    dispatch(changeUserPreference(PREFERENCE.TEMPERATURE_UNITS, units));
  };
};

export const setTimeFormat = (timeFormat: PREFERENCE_TIME_FORMAT) => {
  return (dispatch: Dispatch) => {
    dispatch(changeUserPreference(PREFERENCE.TIME_FORMAT, timeFormat));
  };
};

export const setThemeMode = (themeMode: THEME_TYPE) => {
  return (dispatch: Dispatch) => {
    dispatch(changeUserPreference(PREFERENCE.THEME_MODE, themeMode));
  };
};

export const setMapViewMode = (mapViewMode: MAP_VIEW_MODE) => {
  return (dispatch: Dispatch) => {
    dispatch(changeUserPreference(PREFERENCE.MAP_VIEW_MODE, mapViewMode));
  };
};

export const fetchUserPreferences = () => async (dispatch: Dispatch) => {
  const preferences = await getUserPreferences({ params: undefined }) as UserPreferencesReduxState;

  if (!preferences[PREFERENCE.LOCALE]) preferences[PREFERENCE.LOCALE] = LOCALE_KEY.ENGLISH;
  if (!preferences[PREFERENCE.TIME_FORMAT]) preferences[PREFERENCE.TIME_FORMAT] = PREFERENCE_TIME_FORMAT.TWENTY_FOUR_HRS;
  if (!preferences[PREFERENCE.TIMEZONE]) preferences[PREFERENCE.TIMEZONE] = 'local';
  if (!preferences[PREFERENCE.THEME_MODE]) preferences[PREFERENCE.THEME_MODE] = THEME_TYPE.LIGHT;
  if (!preferences[PREFERENCE.MAP_VIEW_MODE]) preferences[PREFERENCE.MAP_VIEW_MODE] = MAP_VIEW_MODE.REGULAR;
  if (!preferences[PREFERENCE.DEFAULT_APP]) preferences[PREFERENCE.DEFAULT_APP] = PAGE.commandCenterDashboard;

  changeLanguage(preferences[PREFERENCE.LOCALE]);

  //Remove map style because other PACK dont use map style inheritance
  if (getCurrentPack() !== PACK.suv) {
    delete preferences[PREFERENCE.SUV_MAP_STYLE];
  }

  //set all user preferences
  dispatch({ type: SET_USER_PREFERENCES, payload: preferences });

  (Object.keys(preferences) as PREFERENCE[]).forEach((key) => {
    const actionType = PREFERENCES_ACTIONS[key];
    if (actionType) {
      dispatch({ type: actionType, payload: preferences[key] });
    }
  });

};